import React from "react";
import { useGlobalContext } from "../../context/cart_context";
import AmountButtons from "../AmountButtons/AmountButtons";
import "./Cart.css";
import Hidden from "@mui/material/Hidden";
import { Link, withRouter } from "react-router-dom";
import { getDeleteCart } from "../../redux/action/cart/CartAction";
import Grid from "@mui/material/Grid";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// const CartItem = React.memo(function CartItem({
//   id,
//   name,
//   image,
//   price,
//   amount,
// }) {
//   const { remove, decrease, increase } = useGlobalContext();

//   return (

//       <Grid container className="title">
//             <Grid item xs={3}>
//               <img src={image} alt={name} />
//             </Grid>
//             <Grid item xs={3}>
//               <h5 className="name">{name}</h5>
//             </Grid>

//               <Grid item  Hidden smUp>
//                 <h5 className="price-small">&#36;{price}</h5>
//               </Grid>

//       {/* <AmountButtons
//         amount={amount}
//         inc={() => increase(id)}
//         dec={() => decrease(id)}
//       /> */}
//           <Grid item xs={3}>
//               <h5 className="subtotal">&#36;{price * amount}</h5>
//           </Grid>

//           <Grid item xs={3} style={{display: "flex",justifyContent: "center"}}>
//           <button type="button" className="remove-btn" onClick={() => remove(id)}>
//             <i className="fa fa-trash"></i>
//           </button>
//           </Grid>
//     </Grid>
//   );
// });
class CartItem extends React.Component {
  constructor() {
    super();
  }
  deleteCart = (id) => {
    this.props.getDeleteCart(id);
  };
  render() {
    return (
      <div style={{ display: "grid", gridTemplateColumns: "15% auto auto auto auto auto", alignItems: "center", width: "100%" }}>
        <img src={this.props.prod.image} alt={this.props.prod.name} style={{ height: 150 }} />
        <h5 className="name">{this.props.prod.name}</h5>
        <h5 className="name">
          &#36;{this.props.prod.price.toLocaleString("en-IN")}
        </h5>
        <h5 className="name">
          &#36;{this.props.prod.TotalAmount.toLocaleString("en-IN")}
        </h5>
        <span className="name">
          {this.props.prod.productRequired}
        </span>
        {/* <button
          type="button"
          className="remove-btn"
          onClick={() => this.deleteCart(this.props.prod.id)}
        >
          <i className="fa fa-trash"></i>
        </button> */}
      </div>
      // <Grid container className="title">
      //   <Grid item xs={3}>
      //     <img src={this.props.prod.image} alt={this.props.prod.name} />
      //   </Grid>
      //   <Grid item xs={3}>
      //     <h5 className="name">{this.props.prod.name}</h5>
      //   </Grid>

      //   <Grid item Hidden smUp>
      //     <h5 >&#36;{this.props.prod.price.toLocaleString("en-IN")}</h5>
      //   </Grid>

      //   <Grid item xs={3}>
      //     <h5>&#36;{this.props.prod.TotalAmount.toLocaleString("en-IN")}</h5>
      //   </Grid>

      //   <Grid item xs={3} style={{ display: "flex", justifyContent: "center" }}>
      //     <button
      //       type="button"
      //       className="remove-btn"
      //       onClick={() => this.deleteCart(this.props.prod.id)}
      //     >
      //       <i className="fa fa-trash"></i>
      //     </button>
      //   </Grid>
      // </Grid>
    );
  }
}
const mapStateToProps = (state) => ({
  // entryFormList: state.EntryFormList.entryFormList,
  // bankList:
  //   state.BankList.bankList.data != null &&
  //     state.BankList.bankList.data.length != 0
  //     ? state.BankList.bankList.data
  //     : [],
  // loader: state.EntryFormList.isLoading,
  // loginDetails:state.Login.loginDetails.Table1!=null&&state.Login.loginDetails.Table1.length!=0?state.Login.loginDetails.Table1:[],
});
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getDeleteCart }, dispatch);
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CartItem)
);
